import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticatedGuardService} from 'app/archivage/common/guards/guards.service';
import {LoaningEditComponent} from './loaning-edit/loaning-edit.component';
import {ConsultationComponent} from './consultation/consultation.component';
import {MyLoaningsComponent} from './my-loanings/my-loanings.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {path: '', component: MyLoaningsComponent, canActivate: [AuthenticatedGuardService]},
      {path: 'nouvelle-consultation', component: LoaningEditComponent, canActivate: [AuthenticatedGuardService]},
      {path: 'edition-consultation/:id', component: LoaningEditComponent, canActivate: [AuthenticatedGuardService]},
      {path: 'edition-consultation/:id/:message', component: LoaningEditComponent, canActivate: [AuthenticatedGuardService]},
      {path: ':id', component: ConsultationComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoaningRoutingModule {
}
